<template>
  <div id="app">
    <v-app id="inspire" color="grey">
      <v-content>
        <router-view />
      </v-content>
      <v-footer class="pa-3" color="white" app>
        <v-spacer></v-spacer>
        <div class="black--text">
          KNDI &copy; {{ new Date().getFullYear() }}
        </div>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
//import nav_tool from "@/components/nav_tool"
export default {
  name: "App",
  components: {
    //nav_tool
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue